export default "__VITE_ASSET__C31I42Ke__"